import { render, staticRenderFns } from "./wordM10.vue?vue&type=template&id=bf33bc9e&scoped=true&"
import script from "./wordM10.vue?vue&type=script&lang=js&"
export * from "./wordM10.vue?vue&type=script&lang=js&"
import style0 from "./wordM10.vue?vue&type=style&index=0&id=bf33bc9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf33bc9e",
  null
  
)

export default component.exports